import { useEffect } from "react";
import ArenaHeader from "../../../GamesArena/Common/ArenaHeader";
import { useNavigate, useSearchParams } from "react-router-dom";
import { useState } from "react";
import { doc, getDoc } from "firebase/firestore";
import { db } from "../../../firebase-config";
import UpcomingTournamentCarousel from "../Tournament/UpcomingTournamentCarousel";
import PracticeTournamentCarousel from "./carousel";
import axios from "axios";
import { useAuth } from "../../../providers/auth-provider";
import Loader from "../Loader";


const CompletedTournamentLobby = () => {
    const navigate = useNavigate();
    const [tournaments, setTournaments] = useState([]);
    const [subjectWiseTournaments, setSubjectWiseTournaments] = useState([]);
    const { user } = useAuth();
    const [isLoading, setIsLoading] = useState(true);

    useEffect(() => {
        async function fetchData() {
            const tData = await getDoc(doc(db, "tournaments", "17082024_Science_L1_G45_Final"));
            if (tData.exists()) {
                const duplicatedDate = [];
                for (let i = 0; i < 2; i++) {
                    const isLocked = i % 2 === 0;
                    duplicatedDate.push({ ...tData.data(), isLocked, id: tData.id });
                }
                setTournaments(duplicatedDate);
            }
        }
        fetchData();
    }, []);

    useEffect(() => {
        async function fetchUserTournaments() {
            const response = await axios.post(`${process.env.REACT_APP_NODE_BASE_URL}/tournamentPractice/get-user-tournaments`, {
                userId: user?.id,
                tenantStatus: user?.tenantStatus,
            });
            setSubjectWiseTournaments(response.data.data);
            setIsLoading(false);
        }
        fetchUserTournaments();
    }, []);

    const handleGoBack = () => {
        navigate("/lobby");
    }

    return (
        <div className="h-full w-full overflow-auto flex flex-col">
            <ArenaHeader
                goBack={handleGoBack}
                headerText="Past Tournaments"
                nonArenaRoute={true}
            />

            {isLoading ? (
                <div className="flex justify-center items-center h-full">
                    <Loader />
                </div>
            ) : (
                <div className="">
                    {Object.keys(subjectWiseTournaments).map((subject) => (
                        subjectWiseTournaments?.[subject]?.length ? (
                            <div key={subject} className="mt-5">
                                <div key={subject}
                                    style={{
                                        fontFamily: '"Avenir", sans-serif',
                                        fontSize: "18px",
                                        marginLeft: "16px",
                                        marginBottom: "8px",
                                        color: "#FFFFFF",
                                    }}
                                >
                                    {subject}</div>
                                <PracticeTournamentCarousel
                                    tournaments={subjectWiseTournaments?.[subject]}
                                    setActiveSlide={() => { }}
                                />
                            </div>
                        ) : null
                    ))}
                </div>
            )}

        </div>
    )
}

export default CompletedTournamentLobby;
